var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message.template.type === "buttons"
    ? _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
        _vm.message.template.titile
          ? _c("div", { staticClass: "card-header" }, [
              _vm._v("\n    " + _vm._s(_vm.message.template.titile) + "\n  ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("div", { staticClass: "mb-3" }, [
              _c("b", [_vm._v(_vm._s(_vm.message.template.text))])
            ]),
            _vm._v(" "),
            _vm._l(_vm.message.template.actions, function(action, index) {
              return _c("div", { class: { "pt-3": index > 0 } }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    class: action.style,
                    on: {
                      click: function($event) {
                        return _vm.sendMessage(action)
                      }
                    }
                  },
                  [_vm._v(_vm._s(action.text) + "\n      ")]
                )
              ])
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3008b1dc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3008b1dc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/TemplateMessage.vue
// module id = 2247
// module chunks = 0